

























import Vue from 'vue';
import Component from 'vue-class-component';
import { InternalSite, Employee, siteAdminApis, adminType, SiteRole } from '../../api';
import EmployeeTransfer from '../../components/EmployeeTransfer.vue';
import SitePermsTable from './SitePermsTable.vue';
import SiteRolesTable from './SiteRolesTable.vue';

@Component({
  components: { EmployeeTransfer, SitePermsTable, SiteRolesTable }
})
export default class SiteDetail extends Vue {
  readonly labelWidth = '6rem';

  siteAdminsDialogVisible = false;
  employees: Array<Employee> = [];
  admins: Array<Employee> = [];
  activeTab = 0;
  tabValue = 'perm_role';
  admin_type = '1';
  admin_title = '';
  siteId = 0;
  finished = false;
  loading = false;
  roles: Array<SiteRole> = [];
  pullLoading = false;

  getRouteSite() {
    const routeSiteId = parseInt(this.$route.params.id);
    if (Number.isInteger(routeSiteId)) {
      this.siteId = routeSiteId;
    }
    return routeSiteId;
  }
  mounted() {
    this.$watch(this.getRouteSite, function() {
      this.tabValue = 'perm_role';
      this.activeTab = 0;
      this.siteId = this.getRouteSite();
    });
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  get canEditSite() {
    return this.$store.getters['perms/has']('superadmin');
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }

  showAdmins(type: string) {
    const admin_type = adminType[type];
    siteAdminApis.getAdmins(this.site.id, admin_type).then(admins => {
      this.admins = admins;
    });
    if (admin_type == adminType['Configurator']) {
      this.admin_title = '配置管理员';
    } else {
      if (admin_type == adminType['Auditor']) {
        this.admin_title = '审计管理员';
      } else {
        this.admin_title = '授权管理员';
      }
    }
    this.siteAdminsDialogVisible = true;
    this.admin_type = admin_type;
  }

  async grantAdmin(employee: Employee) {
    await siteAdminApis.grantAdmin(this.site.id, employee.id, this.admin_type);
    this.admins.push(employee);
    this.$notify.success('添加管理员成功');
  }

  async revokeAdmin(employee: Employee) {
    await siteAdminApis.revokeAdmin(this.site.id, employee.id, this.admin_type);
    const idx = this.admins.findIndex(x => x.id === employee.id);
    if (idx > -1) {
      this.admins.splice(idx, 1);
    }
    this.$notify.success('删除管理员成功');
  }

  async deleteSite() {
    const site = this.site;
    await this.$store.dispatch('sites/delete', site);
    this.$notify.success(`删除站点[ ${site.title} ]成功`);
    this.$router.push('/sites');
  }

  onChange(index: number) {
    switch (index) {
      case 0:
        this.tabValue = 'perm_role';
        return;
      case 1:
        this.tabValue = 'perm';
        return;
    }
  }
}
